import React, { createContext, useState, useEffect } from 'react'
import {
  Loading,
  MenuBar,
  Hamburger,
  WorkModal,
  LanguageProvider,
} from '~/components'
import { TransitionProvider, TransitionViews } from 'gatsby-plugin-transitions'
import { PageProps } from 'gatsby'
import { Hero } from '~/sections'

interface Context {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  openWorkModal: () => void
  openHamburger: () => void
}

export const context = createContext<Context>(null)

const layout = (loadingDefault: boolean, { children, location }: PageProps) => {
  const [loading, setLoading] = useState(loadingDefault)
  const [loadingActive, setLoadingActive] = useState(loadingDefault)
  const [hamburgerOpen, setHamburgerOpen] = useState(false)
  const [workModalOpen, setWorkModalOpen] = useState(false)

  const [enterOpacity, setEnterOpacity] = useState(0.9999)
  useEffect(() => {
    setEnterOpacity(0)
    if (location.pathname === '/dvert-residence/acompanhe-a-obra/')
      setWorkModalOpen(true)
  }, [])

  return (
    <>
      {loading && <Loading active={loadingActive} />}
      <LanguageProvider>
        <context.Provider
          value={{
            setLoading: (value: boolean) => {
              if (value) {
                setLoading(true)
                setLoadingActive(true)
                setTimeout(() => setLoading(false), 500)
              } else {
                setLoadingActive(false)
                setTimeout(() => setLoading(false), 500)
              }
            },
            openHamburger: () => {
              setHamburgerOpen(true)
            },
            openWorkModal: () => setWorkModalOpen(true),
          }}
        >
          <Hero />
          <MenuBar />
          <Hamburger
            open={hamburgerOpen}
            onClose={() => setHamburgerOpen(false)}
          />
          <WorkModal
            open={workModalOpen}
            onClose={() => setWorkModalOpen(false)}
          />
          <TransitionProvider
            location={location}
            mode="immediate"
            enter={{
              opacity: enterOpacity,
            }}
            usual={{
              opacity: 1,
            }}
            leave={{
              opacity: 0,
              config: {
                duration: 200,
              },
            }}
          >
            <TransitionViews>{children}</TransitionViews>
          </TransitionProvider>
        </context.Provider>
      </LanguageProvider>
    </>
  )
}

export default (props: PageProps) => {
  const context = props.pageContext as { [key: string]: never }
  if (context?.layout === '404') return layout(true, props)
  return layout(false, props)
}
